import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const createKey = () => ['stage_address_life_cycle'];

const fetch = () =>
  request.get(
    `FlatsGrid/stage_address_life_cycle`,
    {},
    `Произошла ошибка при загрузке стадий ЖЦ`
  );

const useStagesLifeCycleQuery = (options) =>
  useQuery(createKey(), fetch, options);

export default useStagesLifeCycleQuery;
